import { logger, interaction } from "@origin-digital/reporting-client";
import { getEnv } from "./helper";
import initialize from "./intercom";

export interface IIntercomSettings {
  user_id?: string;
  user_hash?: string;
  hide_default_launcher?: boolean;
  custom_launcher_selector?: string;
}

export function initIntercom(settings?: IIntercomSettings): void {
  const appId = getEnv() === "prod" ? "hs2d6jw6" : "pllf553u";
  if (document.readyState === "complete") {
    install(appId, settings);
  } else {
    window.addEventListener(
      "load",
      function () {
        install(appId, settings);
      },
      false
    );
  }
}

function install(appId: string, settings?: IIntercomSettings): void {
  createSettingsInWindow(appId, settings);
  initialize(appId);
  addAnalyticsOnShow();
}

export function createSettingsInWindow(
  appId: string,
  settings?: IIntercomSettings
): void {
  const { user_id, user_hash, ...rest } = settings || {};

  window.intercomSettings =
    user_id && user_hash
      ? {
          app_id: appId,
          user_id,
          user_hash,
          mcid: getMarketingCloudVisitorID(),
          custom_launcher_selector: ".oe_chat_launcher",
          ...rest,
        }
      : {
          app_id: appId,
          mcid: getMarketingCloudVisitorID(),
          custom_launcher_selector: ".oe_chat_launcher",
          ...rest,
        };
}

function getMarketingCloudVisitorID(): string | null {
  try {
    const mcid = window["_satellite"]
      .getVisitorId()
      .getMarketingCloudVisitorID();
    // eslint-disable-next-line no-negated-condition
    return mcid !== null ? mcid : null;
  } catch (e) {
    logger.error("[od/chat]: failed to get MarketingCloudVisitorID", e);
    return null;
  }
}

function addAnalyticsOnShow(): void {
  if (window.Intercom) {
    window.Intercom("onShow", function () {
      interaction("click", {
        componentType: "button",
        id: "open-chat",
        parentContainer: "intercom",
        label: "open chat widget",
      });
    });
  } else {
    logger.error("[od/chat]: failed to add analytics: open-chat: web");
  }
}
